import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SidenavMenuLink } from '@core/models';

@Component({
    selector: 'app-sidenav-list-item',
    templateUrl: './sidenav-list-item.component.html',
    styleUrls: ['./sidenav-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidenavListItemComponent implements OnInit {
  static readonly componentName = 'SidenavListItemComponent';
  
  _route: string;
  _link: SidenavMenuLink;

  // an item with children (Setup's pages): whether they show (closed to start), and whether one is the current page
  public expanded = false;
  public childActive = false;
  public childrenId: string;
  private activeChildren = new Set<string>();

  get route(): string {
    return this._route;
  }

  get link(): SidenavMenuLink {
    return this._link;
  }
  @Input() set link(val: SidenavMenuLink) {
    this._link = val;
    this._route = val.route;
    this.childrenId = `sidenav-${val.route}-children`;
  }
  @Output() linkClick = new EventEmitter<SidenavMenuLink>();
  @Output() logout = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  handleLogout(): void {
    this.logout.emit();
    this.linkClick.emit();
  }

  handleLinkClick(link: SidenavMenuLink): void {
    this.linkClick.emit(link);
  }

  onChildActiveChange(route: string, isActive: boolean): void {
    if (isActive) {
      this.activeChildren.add(route);
    } else {
      this.activeChildren.delete(route);
    }
    this.childActive = this.activeChildren.size > 0;
  }
}
